import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UniversityComponent} from './university.component';
import {AddUniversityComponent} from './add-university/add-university.component';

const routes: Routes = [
    {
        path: 'university',
        component: UniversityComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university/add',
        component: AddUniversityComponent,
        data: {animation: 'university/add'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UniversityRoutingModule {
}
